import { AnimationSpine } from 'core/display/spines/AnimationSpine'
import { signal } from 'services/SignalsService'
import { choicePopup } from 'settings/custom/freespins'
import { alpha } from 'utils/Tweens'

export default class BonusTwoAnimation extends AnimationSpine {
  constructor(data) {
    super(data)

    signal.on('ACTION:FS-START', this.reset.bind(this))
    signal.on('CHOISE-START', this.makeChoice.bind(this))

  }

  reset(){
    const orientation = this.currentOrientation
    const animationIn = this._data.in + '-' + orientation
    const animationIdle = this._data.animation + '-' + orientation
    this.setToSetupPose()
    this.alpha = 0

    if (this._data.in){
      this.play(animationIn, false).then(() => {
        this.play(animationIdle, true).then()
      })
    }
    else {
      this.play(animationIdle, true).then()
    }
    alpha(this, 1, 0.5, 0)
  }

  makeChoice(){
    const freespins = game.models.FreespinModel.get()
    const animation = freespins.all === choicePopup.first ? `${this._data.anim1}-${this.currentOrientation}` : `${this._data.anim2}-${this.currentOrientation}`
    const animationOut = freespins.all === choicePopup.first ? `${this._data.anim1}-${this._data.out}-${this.currentOrientation}` : `${this._data.anim2}-${this._data.out}-${this.currentOrientation}`
    freespins.all === choicePopup.first ? signal.dispatch('SOUND:CHOICE:FIRST') : signal.dispatch('SOUND:CHOICE:SECOND')

    if(this._data.out) {
      this.play(animation, false).then(() => {
        signal.dispatch('CHOICE-READY')
        this.play(animationOut, false).then(() => {
          alpha(this, 0, 0.5, 0)
          this.stop()
        })
      })
    }
    else {
      this.playCallBack( animation, false, () => {
        alpha(this, 0, 1, 0)
        this.stop()
        signal.dispatch('CHOICE-READY')
      })
    }
  }
}
